<template>
  <div class="home">
    <dialog
      id="dog"
      :open="isdog"
      status="no"
      style="
        z-index: 99;
        position: fixed;
        top: 0;
        width: 100%;
        height: 100vh;
        background-color: #0e0e0ec0;
        border: none;
      "
    >
      <div
        style="
          width: 1000px;
          background-color: aliceblue;
          padding: 15px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
      >
        <div
          style="
            width: 100%;
            height: 50px;
            background-color: aliceblue;
            margin-bottom: 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <span style="color: #0365f8">视频播放</span>
          <span
            @click="godog"
            style="
              width: 30px;
              height: 30px;
              background-color: #ff0000;
              border-radius: 50%;
              cursor: pointer;
              text-align: center;
              line-height: 30px;
              color: aliceblue;
            "
          >
            X
          </span>
        </div>
        <video
          id="vid"
          controls
          style="width: 100%"
          src="../assets/sp001.mp4"
        ></video>
      </div>
    </dialog>

    <el-carousel height="800px" :autoplay="true" :interval="5000">
      <el-carousel-item style="text-align: center">
        <div
          style="
            width: 100%;
            height: 100%;
            background-image: url('../assets/goin2.png');
          "
        >
          <img
            src="../assets/banner-forth.png"
            @click="goActivity"
            style="height: 100%"
            alt=""
          />
        </div>
      </el-carousel-item>
      <el-carousel-item class="head">
        <img
          class="bg"
          @click="gowq"
          src="../assets/image/home-bg.png"
          alt=""
        />
        <p class="title" @click="gowq">
          <img
            src="../assets/image/icon-sunny.png"
            alt=""
            class="icon-weather"
          />玩转科学，乐享其中
        </p>
        <p @click="gowq">科学玩家</p>
        <p @click="gowq">
          首创校园气象STEM课程体系，<br />
          依据《义务教育小学科学课程标准》、<br />
          《中小学综合实践活动课程指导纲要》、<br />
          融合STEM、PBL设计理念，符合国家教育双减政策
        </p>
      </el-carousel-item>
      <el-carousel-item style="text-align: center">
        <div
          style="
            width: 100%;
            height: 100%;
            background-image: url('../assets/goin2.png');
          "
        >
          <img
            src="../assets/goin1.jpg"
            @click="goGis"
            style="height: 100%"
            alt=""
          />
        </div>
      </el-carousel-item>
      <el-carousel-item style="text-align: center">
        <img
          src="../assets/goin2.png"
          @click="godog"
          style="height: 100%"
          alt=""
        />
      </el-carousel-item>
      <el-carousel-item style="text-align: center">
        <img
          src="../assets/lunbotu3.png"
          @click="goWeb"
          style="height: 100%"
          alt=""
        />
      </el-carousel-item>
    </el-carousel>
    <!-- <div style="text-align: center; margin: 20px 0;"  @click="goActivity">
      <img src="../assets/横栏（点击后弹出报名+观测页面）.png" alt="" style="width: 100%;"/>
    </div> -->
    <div class="middle" @click="goActivity">
      <img src="../assets/forth.png" alt="" />
    </div>

    <div class="content_box">
      <div class="item" @click="goGis">
        <img src="../assets/icon-kxgcw.png" alt="" class="icon" />
        <p class="name">科学观测网</p>
        <p class="text">查看年度科学探索活动和赛事</p>
      </div>
      <div class="item" @click="goht">
        <img src="../assets/icon-tqjgl.png" alt="" class="icon" />
        <p class="name">天气警告铃</p>
        <p class="text">订阅天气铃以提前获取天气变化信息</p>
      </div>
      <!-- <div class="item" @click="gowe">
        <img src="../assets/icon-zndmtzd.png" alt="" class="icon" />
        <p class="name">智能多媒体终端</p>
        <p class="text">多媒体交互体验终端</p>
      </div> -->
      <div class="item" @click="goContest">
        <img src="../assets/icon-dsjxyds.png" alt="" class="icon" />
        <p class="name">第三届校园气象</p>
        <p class="text">观测和应用挑战赛</p>
      </div>
      <div class="item" @click="gozx">
        <img src="../assets/icon-qxkpg.png" alt="" class="icon" />
        <p class="name">气象科普馆</p>
        <p class="text">大众气象科普业务</p>
      </div>
      <div class="item" @click="gozx">
        <img src="../assets/icon-qxywxt.png" alt="" class="icon" />
        <p class="name">气象业务系统</p>
        <p class="text">多种气象业务系统开发</p>
      </div>
      <div class="item" @click="gozx">
        <img src="../assets/icon-xyqx.png" alt="" class="icon" />
        <p class="name">校园气象</p>
        <p class="text">玩转科学，乐享其中</p>
      </div>
    </div>
    <div class="middle" @click="goGis">
      <img src="../assets/lianmeng.png" alt="" />
    </div>

    <div style="text-align: center" @click="goStudy">
      <img src="../assets/sykc.png" alt="" style="width: 100%" />
    </div>
  </div>
</template>

<script>
import { ROOT } from "@/services/base";
import { $lesson } from "@/services";
export default {
  name: "Home",
  data() {
    return {
      isdog: false,
      menuList: [],
    };
  },
  created() {
    $lesson.getMenuList().then((res) => {
      this.menuList = res.data.map((menu) => {
        return {
          ...menu,
          _icon: `${ROOT}/${menu.icon}`,
        };
      });
    });
  },
  methods: {
    godog() {
      let m = document.getElementById("vid");
      if (this.isdog) {
        m.pause();
      } else if (!this.isdog) {
        m.play();
      }
      this.isdog = !this.isdog;
    },
    goWeb() {
      window.open("http://xyqx.cms1924.org/WebPage/index.aspx", "_blank");
    },
    goStudy(id) {
      this.$router.push({
        name: "onlineStudy",
        params: {
          group: id,
        },
      });
    },
    goGis() {
      // this.$router.push("/map");
      // this.props.history.push('/map')

      const router = this.$router.resolve({ path: "/map" });
      window.open(router.href, "_blank");
    },
    goActivity() {
      const router = this.$router.resolve({
        path: "/info",
        query: { auto: true },
      });
      window.open(router.href, "_blank");
    },
    goContest() {
      const router = this.$router.resolve({
        path: "/info",
        query: { version: 3 },
      });
      window.open(router.href, "_blank");
    },
    goht() {
      window.open(
        "https://mp.weixin.qq.com/s/SnoslZcynajhAuH77ITCgQ",
        "_blank"
      );
      // window.location = "https://mp.weixin.qq.com/s/cdgJdqIFNJItnqu5zCnuww"
    },
    gowe() {
      window.open(
        "https://mp.weixin.qq.com/s/JLks38pjlw38pgJGeEv31A",
        "_blank"
      );
      // window.location = "https://mp.weixin.qq.com/s/JLks38pjlw38pgJGeEv31A"
    },
    gowq() {
      // window.open('https://mp.weixin.qq.com/s/nqe7cg2DuLugY4ekTLy38Q', '_blank')
      window.open(
        "https://mp.weixin.qq.com/s/bCB10HyxsJroOr56K5JKvg",
        "_blank"
      );
      // window.location = "https://mp.weixin.qq.com/s/nqe7cg2DuLugY4ekTLy38Q"
    },
    gozx() {
      this.$router.push("/qixiang");
    },
  },
};
</script>

<style lang="less">
.home {
  position: relative;

  .head {
    background: #fff45c;
    padding: 200px 300px;

    .bg {
      width: 63%;
      position: absolute;
      z-index: 3;
      right: 0;
      top: 0;
      user-select: none;
    }

    p {
      margin: 0;

      &:first-of-type {
        font-size: 62px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #191c1f;
        line-height: 98px;
        position: relative;

        .icon-weather {
          position: absolute;
          left: -87px;
          top: -144px;
        }
      }

      &:nth-of-type(2) {
        font-size: 62px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #e1254f;
        line-height: 98px;
      }

      &:last-child {
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #7078ac;
        line-height: 51px;
      }
    }
  }

  > .content_box {
    width: 100%;
    height: 780px;
    background: linear-gradient(
        0deg,
        fade(#0b01b8, 27) 10%,
        fade(#fdfa03, 27) 50%,
        fade(#ffffff, 27) 90%
      ),
      url("../assets/image/icon-sunny.png") left 20vw top 52px no-repeat,
      url("../assets/image/icon-rainy.png") right 10vw bottom 52px no-repeat;
    padding: 50px 60px;
    z-index: 4;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;

    .item {
      width: 280px;
      height: 368px;
      padding: 45px 20px;
      border-radius: 20px;
      box-shadow: 0px 0px 10px 0px rgba(0, 105, 143, 0.07);
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 20px;

      .icon {
        width: 160px;
      }

      .name {
        font-size: 26px;
        white-space: nowrap;
        color: #484848;
        font-weight: 600;
      }

      .text {
        font-size: 19px;
        line-height: 1.4;
        color: #a6a6a6;
        text-align: center;
      }
    }
  }

  .middle {
    cursor: pointer;
    width: 100%;
  }

  .flex-center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .kecheng {
    margin-top: 39px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    align-items: flex-start;
    justify-content: flex-start;

    .item {
      cursor: pointer;
      margin-top: 39px;
      width: 366px;
      margin-left: 90px;

      &:nth-child(3n + 1) {
        margin-left: 0;
      }

      img {
        width: 100%;
      }

      h3 {
        font-size: 36px;
        color: #000;
        font-weight: bold;
        text-align: center;
      }
    }
  }

  .learn {
    width: 1280px;
    padding: 125px 0;
    margin: 0 auto;
    position: relative;

    .bg {
      position: absolute;
      width: 259px;
      left: 0;
      top: 102px;
    }

    .title {
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #000000;
    }

    .intro {
      margin-top: 24px;
      width: 100%;
      text-align: center;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;
      line-height: 26px;
    }
  }
}

@media screen and (max-width: 1366px) {
  .home > .head {
    padding: 200px 70px;
  }
}
</style>